module.exports = __webpack_public_path__ + "static/homepage1-dacde654a60e08893d552bdaca57d69a.jpg";